import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import logos from './keys/logoKeys'
import ContainerFull from '../../../../components/ContainerFull/index'
import Text from '../../../../components/Text/index'
import Icon from '../../../../components/Icon/index'
import styledContainerQuery from 'styled-container-query'
import ResizeDetector from '../../../../components/ResizeDetector/index'
import { htmlParser } from '../../../../modules/parse'

const StyledContainerArticle = styled(ContainerFull)`
  background-color: ${(props) => props.theme.color.background};
  border: 1px solid ${(props) => props.theme.color.backgroundBorder};
  margin-top: ${(props) => props.theme.sizes.gapVertical};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    margin-top: ${(props) => props.theme.tablet.sizes.gapVertical};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    margin-top: ${(props) => props.theme.mobile.sizes.gapVertical};
  }
`
const List = styled.ul`
  margin: 0;
  padding: 0 1em;
  height: 1.2em;
  overflow: hidden;
  flex: 1;
  padding-left: 1em;
`
const Controls = styled.div`
  font-size: 1.8em;
  margin-bottom: -0.2em;
  display: flex;
`
const ListItem = styled.li`
  list-style: none;
  display: flex;
  align-items: center;
`

const StyledLogo = styled.img`
  height: 25px;

  svg {
    max-width: 100px;
    height: 25px;
  }
`

const StyledIcon = styled(({ disabled, ...props }) => <Icon {...props} />)`
  user-select: none;
  display: block;
  cursor: pointer;
  ${(props) =>
    props.disabled &&
    css`
      color: ${(props) => props.theme.color.textTertiary};
    `};
`

const Wrapper = styledContainerQuery.aside`
  display: flex;
  align-items: center;
  padding-top: 1em;
  padding-bottom: 1em;
  &:container(max-width: 740px) {
    padding-left: ${(props) => props.theme.sizes.gapEdge};
    padding-right: ${(props) => props.theme.sizes.gapEdge};
    flex-direction: column;
    justify-content: center;
  ${ListItem}{
    justify-content: center;
    text-align: center;
  }
  ${StyledLogo}{
    height: 35px;
  }
  ${List} {
    flex-basis: 100%;
    padding: 0;
    margin-top: .5em;
  }
  ${Controls}{
    font-size: 2.8em;
    justify-content: space-between;
  }
  ${StyledIcon}{
    padding-left: 1em;
    padding-right: 1em;
  }
  }
  &:container(max-width: 345px){
    ${StyledIcon}{
      padding-left: 0.5em;
      padding-right: 0.5em;
    }
  }
`

const Label = styled.span`
  color: ${(props) => props.theme.color.textSecondary};
`

class HeadlinePaper extends Component {
  state = {
    currentSlide: 0,
    listItemHeight: 'auto',
  }

  constructor(props) {
    super(props)
    this.headlinesCount = { ...props }.data.length
    this.itemRefs = { ...props }.data.map(() => React.createRef())
  }

  goToSlide = (i) => {
    let nextIndex = this.getRightIndex(i)
    if (nextIndex === false) {
      return
    }
    this.setState({ currentSlide: nextIndex })
  }

  nextHandler = () => {
    this.goToSlide(this.state.currentSlide + 1)
  }

  prevHandler = () => {
    this.goToSlide(this.state.currentSlide - 1)
  }

  getRightIndex = (newIndex) => {
    if (newIndex >= this.headlinesCount || newIndex < 0) {
      return false
    }
    return newIndex
  }

  listItemResizeHandler = () => {
    let highestItem = this.itemRefs.reduce((accumulator, { current }) => {
      const currentHeight = current.style.height
      current.style.height = 'auto'
      const height = current.getBoundingClientRect().height
      current.style.height = currentHeight
      return accumulator > height ? accumulator : height
    }, 0)
    this.setState({ listItemHeight: highestItem })
  }
  render() {
    const { ...props } = this.props
    const logo = logos[this.props.data[this.state.currentSlide].paper]

    return (
      <StyledContainerArticle id="headlinepaper" as="section" {...props}>
        <Wrapper>
          <StyledLogo src={logo} />
          <List style={{ maxHeight: this.state.listItemHeight + 'px', height: this.state.listItemHeight + 'px' }}>
            <ResizeDetector onResize={this.listItemResizeHandler}>
              {this.props.data.map((item, index) => (
                <ListItem
                  key={item.headline + index}
                  style={{
                    transform: `translateY(-${this.state.currentSlide * this.state.listItemHeight}px)`,
                    height: this.state.listItemHeight + 'px',
                  }}
                  ref={this.itemRefs[index]}
                >
                  <Text>
                    <Label>{htmlParser(item.headlineAnnouncement)}</Label>
                    <span> </span>
                    {htmlParser(item.headline)}
                  </Text>
                </ListItem>
              ))}
            </ResizeDetector>
          </List>
          {this.headlinesCount > 1 && (
            <Controls>
              <StyledIcon icon="arrowUp" onClick={this.prevHandler} disabled={this.state.currentSlide === 0} />
              <StyledIcon
                icon="arrowDown"
                onClick={this.nextHandler}
                disabled={this.state.currentSlide >= this.headlinesCount - 1}
              />
            </Controls>
          )}
        </Wrapper>
      </StyledContainerArticle>
    )
  }
}

HeadlinePaper.propTypes = {
  data: PropTypes.array,
}

export default HeadlinePaper
